<template>
    <div id="app"><div class="root-wrap">
        <MenuAside v-bind:propUser="user" v-bind:propBrands="brands" v-bind:propShops="shops" v-bind:propCompany="company" @selectList="$emit('selectList', $event)"/>

        <!-- slotに読込元のファイルが入る -->
        <slot />
    </div></div>
</template>

<script>
import Header from '@/components/Admin/Header'
import MenuAside from '@/components/Admin/MenuAside'
export default {
    components: {
        Header,
        MenuAside,
    },
    props: {
        user: Object,
        brands: Object,
        shops: Object,
        company: Object,
    },
    mounted() {
        ////////////////////////////////////////////////
        //  クリックした要素自身にヘルパークラスをトグルする
        ////////////////////////////////////////////////
        $(".js-toggle-on").click(function () {
            $(this).toggleClass('_on');
        });
    }
}
</script>
